import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAxv4eHdvRxe0F7f9cBta6FdE_0ZDzJbDk",
  authDomain: "app.gaintime.ai",
  projectId: "e-paratext-473817-h4",
  storageBucket: "e-paratext-473817-h4.firebasestorage.app",
  messagingSenderId: "437717191655",
  appId: "1:437717191655:web:e99f9bd4f73ae6e7110b42",
  measurementId: "G-K1WBGZ472W"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);
const storage = getStorage(app);

// connectFunctionsEmulator(functions, "127.0.0.1", 5001)
const CALENDAR_SCOPES = [
  "https://www.googleapis.com/auth/calendar",
  "https://www.googleapis.com/auth/gmail.send",
];

// Step 1: Basic sign-in for account creation (NO scopes)
const firebaseSignInWithGoogle = async () => {
  try {
    const provider = new GoogleAuthProvider();

    // No scopes - just basic email/profile for account creation
    const res = await signInWithPopup(auth, provider);
    return res;
  } catch (e) {
    console.error("Sign-in error:", e);
    return null;
  }
};

// Step 2: Request calendar permissions (WITH scopes)
const requestCalendarPermissions = async (forceConsent = true) => {
  try {
    const provider = new GoogleAuthProvider();

    // Add calendar and gmail scopes
    CALENDAR_SCOPES.forEach((scope) => {
      provider.addScope(scope);
    });

    // Always request offline access and force consent to get refresh token
    // Force consent is necessary because:
    // 1. Google only provides refresh token on first consent
    // 2. If user previously granted permissions, subsequent requests won't include refresh token
    // 3. We need to force the consent screen to get a fresh refresh token
    const customParams = {
      app_name: "gaintime",
      access_type: "offline",
      prompt: forceConsent ? "consent" : undefined,
    };

    provider.setCustomParameters(customParams);

    const res = await signInWithPopup(auth, provider);
    return res;
  } catch (e) {
    console.error("Calendar permission error:", e);

    // If verification code error and we haven't forced consent yet, retry with forced consent
    if (
      e.message?.includes("Error getting verification code from google.com") &&
      !forceConsent
    ) {
      console.log("Retrying with forced consent due to verification error...");
      return await requestCalendarPermissions(true);
    }

    return null;
  }
};

export {
  auth as FirebaseAuth,
  db as FirestoreDB,
  functions as CloudFunctions,
  storage as StorageDB,
  firebaseSignInWithGoogle,
  requestCalendarPermissions,
};
